var html = require('choo/html');
const progressBar = require('../elements/progress_bar');
const QUESTION_TYPES = require('../lib/question_types');
const {
  bgCorrectAnswer,
  bgWrongAnswer,
  textAnswer,
  textCorrectAnswer,
  textWrongAnswer,
  unselectedAnswerStyle,
  stickToBottom
} = require('../lib/styles');

var TITLE = 'Scorecard';

const sectionTitle = 'ttu ti-sans-b';
// var scorecardItemClasses =
//   'mb3 mr3 pb1 pa2 bb b--navy bw1 h5 w-100 overflow-scroll bg-navy dt-white fb';

// var scorecardItemClasses =
//   'mb3 mr3 pb1 pa2 bb b--navy bw1 h5 w5 dib overflow-scroll bg-navy dt-white';

var scorecardItemClassesCorrect = `${bgCorrectAnswer} mb3 mr3 pb1 pa2 h5 w5 dib overflow-scroll overflow-scroll-touch 3 f5 tl`;
var scorecardItemClassesWrong = `${bgWrongAnswer} mb3 mr3 pb1 pa2 h5 w5 dib overflow-scroll overflow-scroll-touch mr3 f5 tl`;

// <ul style="width: 1280px;" class="list pa0 ma0 flex items-stretch">
module.exports = view;

function multiselectChoicesOutput(q) {
  return q.choices.map((c, i) => {
    return html`
      <li>${c}</li>
    `;
  });
}

function multiselectAnswerOutput(q) {
  let answers = new Set(q.answer);

  return q.choices.map((c, i) => {
    return answers.has(i.toString()) ? c : '';
  });
}

function answerDisplay(state) {
  return html`
    <ul
      class="list pa0 ma0 flex items-stretch lh-title"
      style="width: ${state.questions.length * 320}px"
    >
      ${state.questions.map((q, i) => {
        switch (q.type) {
          case QUESTION_TYPES.YES_NO:
            return html`
              <li
                style="width:400px; height: 220px;"
                class="${state.quiztaker.answers[i].chosenAnswer ===
                state.questions[i].answer
                  ? scorecardItemClassesCorrect
                  : scorecardItemClassesWrong}"
              >
                ${state.quiztaker.answers[i].chosenAnswer ===
                state.questions[i].answer
                  ? html`
                      <div class="mb3">
                        <img
                          width="13"
                          src="https://projects.theintercept.com/can-you-spot-the-terrorist/assets/check-blue.svg"
                        />
                        <span class="${textCorrectAnswer}">Correct</span>
                      </div>
                    `
                  : html`
                      <div class="mb3">
                        <img
                          width="13"
                          src="https://projects.theintercept.com/can-you-spot-the-terrorist/assets/x-red.svg"
                        />
                        <span class="${textWrongAnswer}">Wrong</span>
                      </div>
                    `}
                <div>
                  <span class="${sectionTitle}">Question ${q.id}</span
                  >${q.question}
                </div>
                <div class="mt3">
                  ${q.answer === 0
                    ? html`
                        <div>
                          <span class="${sectionTitle}">Answer</span>
                          <br />Yes
                        </div>
                      `
                    : html`
                        <div>
                          <span class="${sectionTitle}">Answer</span>
                          <br />No
                        </div>
                      `}
                </div>
              </li>
            `;
          case QUESTION_TYPES.MULTIPLE_CHOICE:
            return html`
              <li
                style="width:400px; height: 220px;"
                class="${state.quiztaker.answers[i].chosenAnswer ===
                state.questions[i].answer
                  ? scorecardItemClassesCorrect
                  : scorecardItemClassesWrong}"
              >
                ${state.quiztaker.answers[i].chosenAnswer ===
                state.questions[i].answer
                  ? html`
                      <div class="mb3">
                        <img
                          width="13"
                          src="https://projects.theintercept.com/can-you-spot-the-terrorist/assets/check-blue.svg"
                        />
                        <span class="${textCorrectAnswer}">Correct</span>
                      </div>
                    `
                  : html`
                      <div class="mb3">
                        <img
                          width="13"
                          src="https://projects.theintercept.com/can-you-spot-the-terrorist/assets/x-red.svg"
                        />
                        <span class="${textWrongAnswer}">Wrong</span>
                      </div>
                    `}
                <div>
                  <span class="${sectionTitle}">Question ${q.id}</span
                  >${q.question}
                </div>
                <div class="mt3">
                  <span class="${sectionTitle}">Choices</span> <br />
                  <ol class="pl4">
                    ${multiselectChoicesOutput(q)}
                  </ol>
                </div>
                <div class="mt3">
                  <span class="${sectionTitle}">Answer </span><br />${q.choices[
                    q.answer
                  ]}
                </div>
              </li>
            `;

          case QUESTION_TYPES.MULTISELECT_MULTIPLE_CHOICE:
            return html`
              <li
                style="width:400px; height: 220px;"
                class="${state.quiztaker.answers[i].chosenAnswer ===
                state.questions[i].answer
                  ? scorecardItemClassesCorrect
                  : scorecardItemClassesWrong}"
              >
                ${state.quiztaker.answers[i].chosenAnswer ===
                state.questions[i].answer
                  ? html`
                      <div class="mb3">
                        <img
                          width="13"
                          src="https://projects.theintercept.com/can-you-spot-the-terrorist/assets/check-blue.svg"
                        />
                        <span class="${textCorrectAnswer}">Correct</span>
                      </div>
                    `
                  : html`
                      <div class="mb3">
                        <img
                          width="13"
                          src="https://projects.theintercept.com/can-you-spot-the-terrorist/assets/x-red.svg"
                        />
                        <span class="${textWrongAnswer}">Wrong</span>
                      </div>
                    `}
                <div>
                  <span class="${sectionTitle}">Question ${q.id}</span
                  >${q.question}
                </div>
                <div class="mt3">
                  <span class="${sectionTitle}">Choices</span> <br />
                  <ol class="pl3">
                    ${multiselectChoicesOutput(q)}
                  </ol>
                </div>

                <div class="mt3">
                  <span class="${sectionTitle}">Answer</span> <br />
                  ${q.singleAnswer
                    ? q.choices[q.answer]
                    : multiselectAnswerOutput(q)}
                </div>
              </li>
            `;

          default:
            return html`
              <li
                style="width:400px; height: 220px;"
                class="${state.quiztaker.answers[i].chosenAnswer ===
                state.questions[i].answer
                  ? scorecardItemClassesCorrect
                  : scorecardItemClassesWrong}"
              >
                ${state.quiztaker.answers[i].chosenAnswer ===
                state.questions[i].answer
                  ? html`
                      <div class="mb3">
                        <img
                          width="13"
                          src="https://projects.theintercept.com/can-you-spot-the-terrorist/assets/check-blue.svg"
                        />
                      </div>
                    `
                  : html`
                      <div class="mb3">
                        <img
                          width="13"
                          src="https://projects.theintercept.com/can-you-spot-the-terrorist/assets/x-red.svg"
                        />
                      </div>
                    `}
                <div>Question ${q.id}:${q.question}</div>
                <div>${q.choices[q.answer]}</div>
              </li>
            `;
        }
      })}
    </ul>
  `;
}

function view(state, emit) {
  if (state.title !== TITLE) emit(state.events.DOMTITLECHANGE, TITLE);

  //Score check

  const correctAnswers = state.questions.reduce((total, currQuestion) => {
    const chosenAnswerOutput = state.quiztaker.answers.filter(
      answer => answer.id == currQuestion.id
    );

    const chosenAnswerFinal = chosenAnswerOutput[0]
      ? chosenAnswerOutput[0].chosenAnswer
      : '';

    // const chosenAnswer = state.quiztaker.answers.filter(
    //   answer => answer.id == currQuestion.id
    // )[0].chosenAnswer;
    return currQuestion.answer === chosenAnswerFinal ? total + 1 : total;
  }, 0);

  function onload() {
    if (window && window.TI) {
      const shareTweet = new TI.social.twitter.ShareButton({
        text: 'Can You Spot The Terrorist?: Take the quiz',
        url: 'https://projects.theintercept.com/can-you-spot-the-terrorist/',
        via: 'theintercept'
      });

      const shareFb = new TI.social.facebook.ShareButton({
        text: 'Can You Spot The Terrorist?: Take the quiz',
        url: 'https://projects.theintercept.com/can-you-spot-the-terrorist/',
        via: 'theintercept'
      });
    }
  }

  function scoreComment(correctAnswers, totalLength) {
    const scorePercentage = (correctAnswers / totalLength) * 100;
    if (scorePercentage >= 0 && scorePercentage <= 50) {
      return 'Ouch, that’s not good. But don’t be too hard on yourself. The way the U.S. government chooses who to prosecute as a terrorist is wildly inconsistent.';
    } else if (scorePercentage > 50 && scorePercentage < 100) {
      return 'Nice work. Your score is impressive given the U.S. government’s wildly inconsistent approach to prosecuting terrorism.';
    } else if (scorePercentage === 100) {
      return 'Perfect score! The U.S. government’s approach to prosecuting terrorism is wildly inconsistent, but you nailed this. Ever considered a job in the Justice Department?'
    }
  }

  return html`
    <div id="app" class="center mw8-ns lh-copy ti-sans navy" onload="${onload}">
      <ul class="pa0 ma0 ti-sans-b dt-white flex f5 ttu list">
        <li class="pa3 mb2 bg-navy w-50 mr1">All done!</li>
        <li
          class="pa3 mb2 bg-navy w-50 tc pointer ml1"
          onclick="${() => {
            emit('retake-quiz');
          }}"
        >
          <img
            width="14"
            src="https://projects.theintercept.com/can-you-spot-the-terrorist/assets/redo.svg"
          />
          <span class="ml2">Retake quiz</span>
        </li>
      </ul>
      <div id="app" class="mw8-ns ph3">
        <h1 class="f5 f3-ns lh-solid lh-title-ns ti-sans">
          <span class="ti-sans-b"
            >Final Score: ${correctAnswers} out of ${state.questions.length} </span
          ><br />

          ${scoreComment(correctAnswers, state.questions.length)}
        </h1>
        <section class="overflow-scroll overflow-scroll-touch">
          ${state.quiztaker.answers.length > 0 ? answerDisplay(state) : ''}
        </section>
      </div>
      <section class="${stickToBottom}">
        <div
          class="f5 f4-ns ph3 dt-white pv3 mt2 bg-animate bg-blue lh-title bn ti-sans"
        >
          For more information, read the stories in The Intercept’s \
          <a class="dt-white" href="https://theintercept.com/series/the-threat-within/"
            >Threat Within</a
          > series. To join our newsletter, \
          <a class="dt-white" href="https://theintercept.com/newsletter/?campaign_id=project_the-threat-within"
            >click here</a
          >.
        </div>
        <ul class="list pa0 ma0 flex">
          <a
            class="${unselectedAnswerStyle} w-50 mr1 link"
            href="https://www.facebook.com/sharer/sharer.php?u=https%3A//projects.theintercept.com/can-you-spot-the-terrorist/"
            target="_blank"
          >
            <li><span class="pt2 ti-icon--Facebook"></span></li>
          </a>
          <a
            class="${unselectedAnswerStyle} w-50 ml1 link"
            href="https://twitter.com/home?status=Can%20You%20Spot%20The%20Terrorist?%20Guess%20which%20defendants%20the%20government%20prosecuted%20as%20domestic%20terrorists%3A%0A%0ATake%20the%20quiz!%0A%0Ahttps%3A//projects.theintercept.com/can-you-spot-the-terrorist/"
            target="_blank"
          >
            <li><span class="pt2 ti-icon--Twitter w-100"></span></li>
          </a>
        </ul>
      </section>
    </div>
  `;
}

// document.querySelector('.social').appendChild(shareTweet.element);
// document.body.appendChild(shareFb.element);
